// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__vwfE4"};